export const isMobile = window.innerWidth < 576;
